/* sugar:assets/card-swatches.js@2.0.0 */
/*
 * Product card swatches — tapping a swatch on a card shows that color's image and points
 * the card's links at that variant. Delegated from the document so cards that arrive
 * through the filter refetch or the theme editor need no wiring.
 */
(function () {
  'use strict';

  if (window.SugarCardSwatches) return;

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    var card = swatch.closest('.sugar-card');
    if (!card) return;

    event.preventDefault();

    Array.prototype.forEach.call(card.querySelectorAll('[data-card-swatch]'), function (s) {
      var on = s === swatch;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var image = card.querySelector('.sugar-card__image:not(.sugar-card__image--secondary)');
    var src = swatch.getAttribute('data-image');
    if (image && src) {
      image.removeAttribute('srcset');
      image.src = src;
      var srcset = swatch.getAttribute('data-srcset');
      if (srcset) image.srcset = srcset;
      card._swOriginalSrc = src;
      card._swOriginalSrcset = srcset || '';
    }

    var url = swatch.getAttribute('data-url');
    if (url) {
      Array.prototype.forEach.call(card.querySelectorAll('.sugar-card__media-link, .sugar-card__title a'), function (a) {
        a.href = url;
      });
    }
  });

  // Desktop: hovering a swatch previews its image; leaving the row restores the chosen one.
  var HOVER = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };

  function show(card, swatch) {
    var image = card.querySelector('.sugar-card__image:not(.sugar-card__image--secondary)');
    if (!image) return;
    var src = swatch && swatch.getAttribute('data-image');
    if (!src) {
      src = card._swOriginalSrc;
      if (!src) return;
      image.srcset = card._swOriginalSrcset || '';
      image.src = src;
      return;
    }
    image.removeAttribute('srcset');
    image.src = src;
    var srcset = swatch.getAttribute('data-srcset');
    if (srcset) image.srcset = srcset;
  }

  document.addEventListener('mouseover', function (event) {
    if (!HOVER.matches) return;
    var swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    var card = swatch.closest('.sugar-card');
    if (!card) return;
    if (!card._swOriginalSrc) {
      var image = card.querySelector('.sugar-card__image:not(.sugar-card__image--secondary)');
      if (image) {
        card._swOriginalSrc = image.src;
        card._swOriginalSrcset = image.srcset;
      }
    }
    show(card, swatch);
  });

  document.addEventListener('mouseout', function (event) {
    if (!HOVER.matches) return;
    var row = event.target.closest('[data-card-swatches]');
    if (!row || (event.relatedTarget && row.contains(event.relatedTarget))) return;
    var card = row.closest('.sugar-card');
    if (!card) return;
    show(card, row.querySelector('[data-card-swatch].is-active'));
  });

  window.SugarCardSwatches = true;
})();
